import { Select } from 'antd';
import React, { FC, ReactNode } from 'react';
import { Plus } from 'react-feather';

interface Props {
  employees: string[];
  onChange?: any;
  option?: string | number;
  placeholder?: string | ReactNode;
}

const EmployeeSelect: FC<Props> = ({
  employees,
  onChange,
  option,
  placeholder = 'Assign ticket',
}) => {
  return (
    <>
      <Select
        showSearch
        placeholder={placeholder}
        optionFilterProp="med_naam"
        onChange={onChange}
        className="text-sm"
        size="small"
        suffixIcon={<Plus size={10} />}
        options={employees.map((employee) => ({
          value: employee.med_id,
          label: employee.med_naam,
          option: option,
        }))}
      ></Select>
    </>
  );
};

export default EmployeeSelect;
